import { render, staticRenderFns } from "./EditMerchantCompanyComponent.vue?vue&type=template&id=cd7bc738&"
import script from "./EditMerchantCompanyComponent.vue?vue&type=script&lang=js&"
export * from "./EditMerchantCompanyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports